import { useTranslate } from "@similarweb/i18n-provider";
import { shortMonthAndDay } from "@similarweb/pro-logic-components";

import { useAlertsParams } from "../../../hooks/useAlertsParams";

import { DurationSelector } from "./DurationSelector";
import { DurationSelectorButton } from "./DurationSelectorButton";
import { getAlertsSupportedWindowDate } from "./getAlertsSupportedWindowDate";

const AdsTabDurationButton = () => {
    const { translate } = useTranslate();
    const windowDate = getAlertsSupportedWindowDate();
    const buttonText = translate("global.from_window", {
        date: windowDate ? windowDate.format(shortMonthAndDay) : "",
    });

    return (
        <DurationSelectorButton
            isDisabled={true}
            data-automation="duration-selector-control"
        >
            {buttonText}
        </DurationSelectorButton>
    );
};

export const DurationSelectorContainer = () => {
    const { tab } = useAlertsParams();

    if (tab === "ads") {
        return <AdsTabDurationButton />;
    }

    return <DurationSelector />;
};
